<div class="bg-tilled-neutral-100">
  <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
    <mat-icon class="text-primary icon-size-5" [svgIcon]="'mat_solid:more_vert'"></mat-icon>
  </button>
  <mat-menu
    #actionsMenu="matMenu"
    [hasBackdrop]="true"
    [backdropClass]="''"
    [class]="'action-list-menu-arrow-top overflow-hidden rounded-[10px] bg-tilled-primary py-2 text-tilled-neutral-100'"
  >
    <ng-container *ngFor="let actionListItem of actionList">
      <button
        *ngIf="!actionListItem.hasSubMenu"
        mat-menu-item
        [class]="'min-h-6'"
        [disabled]="actionListItem.disabled"
        (click)="actionListItem.callback(actionListItem)"
      >
        <span [class]="'flex items-center text-tilled-neutral-100'">
          <span
            ><tilled-paragraph-p3 [white]="true" [bold]="true">{{ actionListItem.name }}</tilled-paragraph-p3></span
          >
        </span>
      </button>
      <button
        *ngIf="actionListItem.hasSubMenu"
        mat-menu-item
        [class]="'min-h-6 w-full'"
        [disabled]="actionListItem.disabled"
        [matMenuTriggerFor]="actionsSubMenu"
      >
        <div [class]="'flex w-full flex-row justify-between'">
          <span [class]="'text-tilled-neutral-100'">
            <tilled-paragraph-p3 [white]="true" [bold]="true">{{ actionListItem.name }}</tilled-paragraph-p3>
          </span>
          <mat-icon
            class="-mr-7 ml-4 icon-size-5"
            [ngClass]="'text-white'"
            [svgIcon]="'heroicons_outline:chevron-right'"
          ></mat-icon>
        </div>
      </button>
      <mat-menu
        #actionsSubMenu="matMenu"
        [hasBackdrop]="true"
        [backdropClass]="''"
        [class]="'overflow-hidden rounded-[10px] bg-tilled-primary py-2 text-tilled-neutral-100'"
      >
        <ng-container *ngFor="let subItem of actionListItem.subMenu">
          <button
            mat-menu-item
            [class]="'min-h-6'"
            [disabled]="subItem.disabled"
            (click)="subItem.callback(actionListItem)"
          >
            <span [class]="'flex items-center text-tilled-neutral-100 '">
              <span
                ><tilled-paragraph-p3 [white]="true" [bold]="true">{{ subItem.name }}</tilled-paragraph-p3></span
              >
            </span>
          </button>
        </ng-container>
      </mat-menu>
    </ng-container>
  </mat-menu>
</div>
